import { AnalyticsBrandSettings, AnalyticsEventData } from 'idt-analytics-api/models';
import { getDefaultAnalytics } from '../helpers/events.helper';
import { AnalyticsGTMSettings, DefaultAnalyticsSettings } from 'analytics-api';
import { AnalyticsOyshoEventDataHelpers } from '../helpers/brand-analytics-event-data.helpers.oy';

export const FooterEvents: AnalyticsBrandSettings = {

  /** Evento llamado cuando el usuario selecciona otro idioma para visionar la web */
  footerConfiguracionCambiarIdioma(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { componentData } = data;
    const label = componentData.language?.toLowerCase();

    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'configuracion', 'footer', 'cambiar_idioma', label);
    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },

  /**  Se envía al pulsar sobre el país en el que se está en ese momento, a la izquierda de los idiomas disponibles */
  footerConfiguracionCambiarRegion(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { context } = data;
    const label = context.store?.countryName.toLowerCase();

    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'configuracion', 'footer', 'cambiar_region', label);
    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },

  /** Clic en alguna de las categorías del footer Ejem: Sujetadores */
  footerNavegacionClickCategoria(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { componentData } = data;
    let url;
    if (componentData.url) {
      url = new URL(componentData.url);
    }

    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'navegacion', 'footer', 'click_categoria', url?.pathname);
    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },

  /** Clic en 'Contacto' */
  footerAyudaContacto(data: AnalyticsEventData): AnalyticsGTMSettings {
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'ayuda', 'footer', 'contacto', 'contacto');
    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },

  /** Clic en el nombre de las apps del footer (Android o iOS) */
  footerCorporativoDescargaApp(data: AnalyticsEventData): AnalyticsGTMSettings {
    let store;
    if (isDefined(data.componentData.url)) {
      store = data.componentData.url?.indexOf('google') > -1 ? 'google_play' : 'apple_store';
    }

    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'corporativo', 'footer', 'descarga_app', store);
    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },

  /** Clic en 'Acerca de nosotros' */
  footerCorporativoEmpresa(data: AnalyticsEventData): AnalyticsGTMSettings {
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'corporativo', 'footer', 'empresa');
    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },
  /** Clic en un enlace para acceder a una red social */
  footerSocialIrAFacebok(data: AnalyticsEventData): AnalyticsGTMSettings {
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'social', 'footer', 'ir_a_facebook');
    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },

  footerSocialIrAInstagram(data: AnalyticsEventData): AnalyticsGTMSettings {
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'social', 'footer', 'ir_a_instagram');
    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },

  footerSocialIrAPinterest(data: AnalyticsEventData): AnalyticsGTMSettings {
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'social', 'footer', 'ir_a_pinterest');
    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },

  footerSocialIrATwitter(data: AnalyticsEventData): AnalyticsGTMSettings {
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'social', 'footer', 'ir_a_twitter');
    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },

  /** Clic en Join Life */
  footerNavegacionIrAColeccion(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { componentData } = data;
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics(
      'analyticsEvent', 'navegacion', 'footer', 'ir_a_coleccion', componentData.buttonText
    );
    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },

  /** Clic en el teléfono para llamar */
  footerAyudaLLamarTfno(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { componentData } = data;
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics(
      'analyticsEvent', 'ayuda', 'footer', 'llamar_tfno', componentData.buttonText
    );
    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },

  /** Clic en 'Prensa' */
  footerCorporativoPressSite(data: AnalyticsEventData): AnalyticsGTMSettings {
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'corporativo', 'footer', 'press_site');
    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },

  /** Clic en 'Política de cookies' */
  footerLegalVerCookies(data: AnalyticsEventData): AnalyticsGTMSettings {
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'legal', 'footer', 'ver_cookies');
    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },

  /** Clic en 'Envíos y devoluciones' */
  footerAyudaVerEnvio(data: AnalyticsEventData): AnalyticsGTMSettings {
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'ayuda', 'footer', 'ver_envio');
    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },

  /** Clic en 'Preguntas frecuentes' */
  footerAyudaVerFaq(data: AnalyticsEventData): AnalyticsGTMSettings {
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'ayuda', 'footer', 'ver_faq');
    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },

  /** Clic en 'e-Tarjeta Regalo' */
  footerGiftCardVerGiftCard(data: AnalyticsEventData): AnalyticsGTMSettings {
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'gift_card', 'footer', 'ver_gift_card');
    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },

  /** Clic en 'Guía de compra' */
  footerAyudaVerGuiaCompra(data: AnalyticsEventData): AnalyticsGTMSettings {
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'ayuda', 'footer', 'ver_guia_compra');
    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },

  /** Clic en 'Guía de tallas' */
  footerAyudaVerGuiaTallas(data: AnalyticsEventData): AnalyticsGTMSettings {
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'ayuda', 'footer', 'ver_guia_tallas');
    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },

  /** Clic en 'Encuentra tu talla perfecta en la ventana de TrueFit */
  footerAyudaVerGuiaTallasTrueFit(data: AnalyticsEventData): AnalyticsGTMSettings {
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'ayuda', 'footer', 'ver_guia_tallas_true_fit');
    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },
  /** Clic en *Política de Privacidad* */
  footerLegalVerPoliticaPrivacidad(data: AnalyticsEventData): AnalyticsGTMSettings {
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'legal', 'footer', 'ver_politica_privacidad');
    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },

  /** Clic en *Políticas* */
  footerLegalVerPoliticas(data: AnalyticsEventData): AnalyticsGTMSettings {
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'legal', 'footer', 'ver_politicas');
    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },

  /** Clic en *Ticket electrónico* */
  footerAyudaVerTicketElectronico(data: AnalyticsEventData): AnalyticsGTMSettings {
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'ayuda', 'footer', 'ver_ticket_electronico');
    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },

  /** Clic en *Ticket regalo* */
  footerAyudaVerTicketRegalo(data: AnalyticsEventData): AnalyticsGTMSettings {
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'ayuda', 'footer', 'ver_ticket_regalo');
    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },

  /** Clic en *Tiendas* */
  footerCorporativoVerTiendas(data: AnalyticsEventData): AnalyticsGTMSettings {
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'corporativo', 'footer', 'ver_tiendas');
    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },

  /** Clic en *Oysho Wallet* */
  footerCorporativoVerWallet(data: AnalyticsEventData): AnalyticsGTMSettings {
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'corpotativo', 'footer', 'ver_wallet');
    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  }
};
